import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20minimalist%20overhead%20photography%20of%20luxury%20fashion%20shopping%20bags%20boxes%20and%20packaging%20arranged%20beautifully%20on%20warm%20beige%20surface%2C%20soft%20natural%20window%20light%2C%20premium%20retail%20aesthetic%2C%20neutral%20earth%20tones%20cream%20brown%20white%2C%20editorial%20style%20high-end%20ecommerce%20scene&width=1600&height=700&seq=cta-bg&orientation=landscape"
          alt="Shopping"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/60" />
      </div>

      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-5xl font-bold text-white tracking-tight">
          {t('cta.title')}
        </h2>
        <p className="mt-4 text-lg md:text-xl text-white/80 max-w-2xl mx-auto">
          {t('cta.subtitle')}
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white text-foreground-900 font-semibold text-base hover:bg-white/90 transition-all shadow-lg whitespace-nowrap"
          >
            {t('cta.button.main')}
            <i className="ri-external-link-line" />
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-all shadow-lg whitespace-nowrap"
          >
            {t('cta.button.buy')}
            <i className="ri-shopping-bag-line" />
          </a>
        </div>
      </div>
    </section>
  );
}